<template>
  <div>
    <bulk-message-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></bulk-message-table>
  </div>
</template>

<script>
import BulkMessageTable from './table';

export default {
  components: {
    BulkMessageTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
